import {
    DatasourceReturnType,
    ResponseError
} from 'models/common/respone.model';
import {
    WorkflowTaskLogRequest,
    WorkflowTaskLog
} from '../schemas/WorkflowTaskLog.schema';
import {
    retrieveWorkflowTaskLog
} from '../datasource/WorkflowTaskLog.datasource';

export async function getWorkflowTaskLog(
    params: WorkflowTaskLogRequest
): Promise<DatasourceReturnType<ResponseError, WorkflowTaskLog>> {
    try {
        const data = (await retrieveWorkflowTaskLog(params)).data;

        return [null!, data];
    } catch (error) {
        throw error;
    }
}
